/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { DataGrid } from '../../components/datagrid';
import { SearchFilter } from '../../components/inputs/filters/search';
import { PageTitle } from '../../components/PageTitle';
import { AssessmentFormDialog } from '../../components/forms/AssessmentsForm/AssessmentFormDialog';
import { useFetch } from '../../hooks/useFetch';
import { getArrayItems } from '../../utils/FormatFunctions';

const LIST_PATH = '/assessments/list';

export function AssessmentsPage() {
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/ratings`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { requestApi: fetchAssessment } = useFetch(baseUrl);
  const navigate = useNavigate();
  const location = useLocation();
  const { itemId } = useParams();
  const [dialog, setDialog] = useState<{ open: boolean; item: any | null }>({
    open: false,
    item: null,
  });
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (location.pathname.endsWith('/create')) {
      setDialog({ open: true, item: null });
      return;
    }
    if (itemId) {
      fetchAssessment('get', undefined, `${baseUrl}/${itemId}`).then((res: any) => {
        if (res?.data?.data) setDialog({ open: true, item: res.data.data });
      });
    }
  }, [location.pathname, itemId]);

  const closeDialog = () => {
    setDialog({ open: false, item: null });
    if (location.pathname !== LIST_PATH) navigate(LIST_PATH, { replace: true });
  };

  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'rating_topics', label: 'Tópicos' },
  ];

  return (
    <Box>
      <PageTitle description="Acompanhe as avaliações aplicadas e os resultados por turma.">
        Avaliações
      </PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate
        loading={loading}
        refreshKey={refreshKey}
        onCreate={() => setDialog({ open: true, item: null })}
        onEdit={(item) => setDialog({ open: true, item })}
        rowActions={{ show: false, edit: true, delete: true }}
        formatColum={[
          {
            field: 'rating_topics',
            formatField: getArrayItems,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
      />

      <AssessmentFormDialog
        isOpen={dialog.open}
        onClose={closeDialog}
        onSaved={() => setRefreshKey((k) => k + 1)}
        defaultValues={dialog.item ?? undefined}
      />
    </Box>
  );
}
